// src/guards/RegistrationGuard.tsx

import {Navigate, useLocation} from 'react-router-dom'
import {FC} from 'react'
import {useReduxAuth} from '../../../auth'

const RegistrationGuard: FC<{children: JSX.Element}> = ({children}) => {
  const {currentUser} = useReduxAuth()
  const location = useLocation()

  const urlParams = new URLSearchParams(location.search)
  const token = urlParams.get('token')

  if (currentUser && currentUser.role_id !== 5) {
    // Logged-in user trying to access registration (not billing)
    return <Navigate to='/dashboard' replace />
  }

  if (!token) {
    // No token provided — restrict
    return <Navigate to='/unauthorized' replace />
  }

  return children
}

export default RegistrationGuard
